import * as React from 'react';
import {observer} from 'mobx-react';
import {getFileExtention, isAPic, getPreviewIcon} from '../utils/FooterUtils';
import {
    openAttachment,
    openFilePreviewContextMenu
} from '../../../_shared/GWTBridge/invoke/footerPanel';
import {Icon, PriorityIcon} from '@priority-software/priority-style-react';

export const FilePreview = observer(({previewFileName}) => {
    const fileExtention = getFileExtention(previewFileName);
    return (
        <div className="file-preview-container">
            {previewFileName && isAPic(fileExtention) ? (
                <React.Fragment>
                    <div className="big-preview">
                        <img src={previewFileName} alt="" />
                    </div>
                    <img
                        className="file-preview"
                        src={previewFileName}
                        onClick={openAttachment}
                        onContextMenu={event =>
                            openFilePreviewContextMenu(event.clientX, event.clientY)
                        }
                        alt=""
                    />
                </React.Fragment>
            ) : (
                <Icon
                    skin="standart"
                    darkContainer
                    icon={
                        !previewFileName ? PriorityIcon.attachment : getPreviewIcon(fileExtention)
                    }
                    onClick={openAttachment}
                    onContextMenu={event =>
                        openFilePreviewContextMenu(event.clientX, event.clientY)
                    }
                />
            )}
        </div>
    );
});
